import { fundsManagementTracker } from '@mobi/account/Common/Analytics'
import { toastIds } from '@mobi/account/Utils/constants'
import { type PayIdDetails } from '@mobi/api-types/src/account/betAccount'
import { addToast } from '@mobi/component-library/Feedback/Toast'
import { addCrumb } from '@mobi/utils'
import { reportErrorIfNeeded } from '../../../Utils/sentry'

export const FeedbackPayIdStatusChange = (
  accountNumber: number,
  status: PayIdDetails['CreationStatus']
) => {
  switch (status) {
    case 'active':
      addCrumb('deposit', 'PayId zepto active')
      fundsManagementTracker({ interaction_type: 'Generate PayID Success' })
      addToast({
        id: toastIds.payIdActivationSuccess,
        isDismissable: true,
        title: 'Your PayID has been generated.',
        icon: 'success',
      })
      break
    case 'failed':
      reportErrorIfNeeded({ message: 'PayId zepto failed' })
      fundsManagementTracker({
        interaction_type: 'Generate PayID Error',
        message: `PayId zepto failed`,
      })
      addToast({
        id: toastIds.payIdActivationFailure,
        isDismissable: true,
        title: 'We’re unable to generate your PayID.',
        subtitle: 'Please call 1300 36 36 88 to resolve the matter.',
        icon: 'error',
      })
      break
    case 'deregistered':
      reportErrorIfNeeded({ message: 'PayId zepto deregistered' })
      fundsManagementTracker({
        interaction_type: 'PayID Deregistered',
      })
      break
    case 'disabled':
      reportErrorIfNeeded({ message: 'PayId zepto disabled' })
      fundsManagementTracker({
        interaction_type: 'PayID Deregistered',
      })
      break
  }
}
